// Single source of truth for who is allowed to sign in to this app.
// Only this email may log in; every other email is rejected.
export const ADMIN_EMAIL = 'admin@chin.vn';

/**
 * Returns true only when the given email is the one authorized admin account.
 * Comparison is case-insensitive and ignores surrounding whitespace.
 */
export function isAuthorizedAdmin(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.toLowerCase().trim() === ADMIN_EMAIL;
}